// Central content & config for Bar Ristorante Gabri

export const INFO = {
  name: "Bar Ristorante Gabri",
  tagline: "Bar · Ristorante · Gelateria",
  street: "Via Como 10",
  city: "Cavi di Lavagna",
  comune: "Lavagna",
  province: "GE",
  cap: "16033",
  phoneDisplay: "328 24 64 286",
  phoneTel: "+393282464286",
  whatsapp: "393282464286",
  email: "Archettivaleria07@gmail.com",
  instagram: "https://www.instagram.com/bar.gabri08",
  hours: "Tutti i giorni · 6:30 – 02:00",
  mapEmbed:
    "https://maps.google.com/maps?width=100%25&height=100%25&hl=it&q=Via%20Como%2010,%2016033%20Cavi%20di%20Lavagna%20GE&t=&z=16&ie=UTF8&iwloc=B&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Bar%20Gabri%20Via%20Como%2010%20Cavi%20di%20Lavagna",
};

export const IMAGES = {
  dish: "/images/dish.jpeg",
  exterior: "/images/exterior.jpeg",
  interior: "/images/interior.jpeg",
  terrace: "/images/terrace.jpeg",
  menuCard: "/images/menu-card.jpeg",
  calamari: "/images/calamari.jpeg",
  cozze: "/images/cozze.jpeg",
  table: "/images/table.jpeg",
  signOld: "/images/sign-old.jpeg",
};
// signOld kept for reference (unused)

export const MENU = [
  {
    id: "antipasti",
    title: "Antipasti",
    items: [
      {
        name: "Filetto di sgombro marinato a caldo",
        desc: "con panzanella mediterranea",
        price: "14",
      },
      { name: "Muscoli alla marinara", desc: "cozze in guazzetto profumato", price: "12" },
      {
        name: "Battuta di Fassona",
        desc: "olio verde, petali di cipolla rossa caramellata e crostino mediterraneo",
        price: "16",
      },
    ],
  },
  {
    id: "primi",
    title: "Primi Piatti",
    items: [
      {
        name: "Spaghetti alla Spezzina",
        desc: "ragù verde di cozze e vongole",
        price: "15",
      },
      {
        name: "Trofie al pesto Genovese",
        desc: "con patate e fagiolini",
        price: "14",
      },
      {
        name: "Calamarata",
        desc: "calamari e pomodorini ciliegini",
        price: "16",
      },
    ],
  },
  {
    id: "secondi",
    title: "Secondi Piatti",
    items: [
      {
        name: "Calamari grigliati",
        desc: "e verdure in scapece",
        price: "18",
      },
      {
        name: "Costata di manzo (ca. 500gr.)",
        desc: "alla griglia con verdure grigliate",
        price: "30",
      },
      {
        name: "Coniglio alla Ligure",
        desc: "pinoli, olive taggiasche e patate schiacciate",
        price: "16",
      },
      {
        name: "Pescato del giorno alla Ligure",
        desc: "selezione fresca di giornata",
        price: "22",
      },
    ],
  },
  {
    id: "dessert",
    title: "Dessert",
    items: [
      {
        name: "Dolci del giorno",
        desc: "variano di giorno in giorno — chiedere al cameriere",
        price: "8",
      },
    ],
  },
];

export const REVIEWS = [
  {
    text: "Il miglior spaghetto alle cozze della riviera. Pesce freschissimo e un'accoglienza da vera famiglia ligure.",
    author: "Marco R.",
    from: "Genova",
  },
  {
    text: "Colazione al mattino e cena la sera, sempre impeccabili. Le trofie al pesto sono da leccarsi i baffi.",
    author: "Giulia B.",
    from: "Chiavari",
  },
  {
    text: "Posto genuino a due passi dal mare di Lavagna. Prezzi onesti, porzioni generose e personale gentilissimo.",
    author: "Andrea F.",
    from: "Sestri Levante",
  },
  {
    text: "Il pescato del giorno era eccezionale. Atmosfera rilassata sul dehors, ci torneremo di sicuro.",
    author: "Chiara M.",
    from: "Rapallo",
  },
];

export function waLink(text) {
  return `https://wa.me/${INFO.whatsapp}?text=${encodeURIComponent(text)}`;
}
